/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOWalletHolderInfoResponseDTO } from "../models/ApiResponseDTOWalletHolderInfoResponseDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class WalletApiService {
  /**
   * Get Wallet holder details
   * Resolves the holder of the account a transfer is going to. Finopay accounts (wallets, static
   * and dynamic virtual accounts) are answered locally. When bankId is supplied and the account is
   * not a Finopay account, the enquiry falls through to that bank. Without bankId only Finopay
   * accounts are resolved.
   * @param walletId
   * @param bankId Bank the payer selected. Optional.
   * @returns ApiResponseDTOWalletHolderInfoResponseDTO OK
   * @throws ApiError
   */
  public static getWalletHolderInfo(
    walletId: string,
    bankId?: string
  ): CancelablePromise<ApiResponseDTOWalletHolderInfoResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/wallet/{walletId}/holder",
      path: {
        walletId: walletId,
      },
      query: {
        bankId: bankId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        501: `Not Implemented`,
        503: `Service Unavailable`,
      },
    });
  }
}
